<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
</script>

<template>
  <AppLayout title="Support">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Support
      </h2>
    </template>

    <div class="py-6">
      <div class="max-w-3xl mx-auto bg-white shadow rounded-lg p-6">
        <p class="mb-4">
          Access our support resources:  <a
                  href="/admin/knowledgebase"
                  class="hover:underline"
                >
                  Knowledgebase
                </a>
        </p>
      </div>
    </div>
  </AppLayout>
</template>